import React from "react";
import UploadStickerForm from "./UploadStickerForm";

interface UploadModalProps {
  isOpen: boolean;
  uploading: boolean;
  onSubmit: (file: File, name: string, category: string) => void;
  onCancel: () => void;
}

const UploadModal: React.FC<UploadModalProps> = ({
  isOpen,
  uploading,
  onSubmit,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full">
        <h2
          className="text-2xl font-bold text-gray-800 mb-6 text-center"
          dir="rtl"
        >
          העלה סטיקר חדש
        </h2>

        <UploadStickerForm
          onSubmit={onSubmit}
          onCancel={onCancel}
          uploading={uploading}
        />
      </div>
    </div>
  );
};

export default UploadModal;
